import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Logo } from './logo.model';

export const getLogo = createAction(
  '[Logo/API] Get Logo',
  props<{ UploadType: string }>()
);

export const putLogo = createAction(
  '[Logo/API] PUT Logo',
  props<{ logo: Logo}>()
);

export const loadLogos = createAction(
  '[Logo/API] Load Logos',
  props<{ logos: Logo[] }>()
);

export const addLogo = createAction(
  '[Logo/API] Add Logo',
  props<{ logo: Logo }>()
);

export const upsertLogo = createAction(
  '[Logo/API] Upsert Logo',
  props<{ logo: Logo }>()
);

export const addLogos = createAction(
  '[Logo/API] Add Logos',
  props<{ logos: Logo[] }>()
);

export const upsertLogos = createAction(
  '[Logo/API] Upsert Logos',
  props<{ logos: Logo[] }>()
);

export const updateLogo = createAction(
  '[Logo/API] Update Logo',
  props<{ logo: Update<Logo> }>()
);

export const updateLogos = createAction(
  '[Logo/API] Update Logos',
  props<{ logos: Update<Logo>[] }>()
);

export const deleteLogo = createAction(
  '[Logo/API] Delete Logo',
  props<{ id: string }>()
);

export const deleteLogos = createAction(
  '[Logo/API] Delete Logos',
  props<{ ids: string[] }>()
);

export const clearLogos = createAction(
  '[Logo/API] Clear Logos'
);
